import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            display: flex;
            input {
                opacity: 0;
                + label {
                    font-size: 12px;
                    color: ${getColor("text.main")};
                }

                & + label::before {
                    content: "";
                    margin-right: 8px;
                    border: 1px solid ${getColor("common.ui6")};
                    height: 14px;
                    width: 14px;
                }

                &:checked:not(:disabled) + label::before {
                    background: ${getColor("common.white")};
                    border-color: ${getColor("common.ui6")};
                }

                &:checked + label::after,
                &:checked:focus + label::after,
                &:focus:not(:disabled) + label::after {
                    content: "";
                    left: 3px;
                    top: 50%;
                    transform: translateY(-50%);
                    height: 8px;
                    width: 8px;
                    background: ${getColor("common.ui8")};
                }
                &:focus,
                &:active {
                    box-shadow: none;
                    :not(:disabled) + label::before {
                        box-shadow: none;
                    }
                }
                &:disabled + label,
                &:focus:disabled + label {
                    cursor: not-allowed;
                    opacity: 0.5;
                }

                &:hover:not(:disabled) + label {
                    cursor: pointer;
                    &:before {
                        border-color: ${getColor("secondary")};
                    }
                }
            }
        `,
    },
    groupDefaultProps: {},
} as xBaseTheme["radio"];
